import { useEffect, useMemo, useState } from 'react';
import type { KeenSliderOptions } from 'keen-slider/react';
import { useKeenSlider } from 'keen-slider/react';
import { RecipeCard, RecipeCardLoading } from '@ui';
import CarouselHeader from '@components/Carousel/components/Header';
import useWindowSize from '@customHooks/useWindowSize';

const RecipesCarouselDesktop = ({
  recipes,
  title,
  isTitleLink,
  smallHeading,
  loop = true
}) => {
  const { isDesktop } = useWindowSize();
  const [loaded, setLoaded] = useState(false);
  const options: KeenSliderOptions = useMemo(
    () => ({
      rubberband: false,
      mode: 'free-snap',
      loop,
      slides: {
        perView: 'auto',
        spacing: 0
      },
      breakpoints: {
        '(min-width: 1280px)': {
          loop,
          slides: {
            perView: 4,
            spacing: 0
          }
        }
      },
      created() {
        setLoaded(true);
      }
    }),
    [loop]
  );
  const [sliderRef, instanceRef] = useKeenSlider(options);

  useEffect(() => {
    if (instanceRef?.current) {
      instanceRef.current?.update(options, 0);
    }
  }, [recipes, instanceRef, options]);

  return (
    <div className='recipes-carousel'>
      <CarouselHeader
        smallHeading={smallHeading}
        isTitleLink={isTitleLink}
        isShowArrows={
          !!(loaded && instanceRef.current && isDesktop && recipes.length > 4)
        }
        title={title}
        prev={instanceRef.current?.prev}
        next={instanceRef.current?.next}
      />
      <div className='recipes-carousel__slider'>
        <div ref={sliderRef} className='keen-slider'>
          {recipes.length > 0
            ? recipes?.map(item => (
                <div key={item.id} className='keen-slider__slide'>
                  <RecipeCard item={item} />
                </div>
              ))
            : Array.from({ length: 5 }).map((_, index) => (
                <div key={`loading-${index}`} className='keen-slider__slide'>
                  <RecipeCardLoading />
                </div>
              ))}
        </div>
      </div>
    </div>
  );
};

export default RecipesCarouselDesktop;
